<template>
  <div>
    <div v-if="this.$route.params.id">
      <transition name="slide-x-transition" mode="out-in">
        <detail />
      </transition>
    </div>
    <div v-if="this.$route.params.name && !this.$route.params.id">
      <transition name="slide-x-transition" mode="out-in">
        <user />
      </transition>
    </div>
    
  </div>
</template>

<script>
import user from "./user.vue";
import detail from "./detail.vue";
//import pool from "./pool.vue";
export default {
  name: "Strategies",
  components: {
    user,
    detail,
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped>
</style>